import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./loginSlice";
import flagReducer from "./flagSlice";
import registerReducer from "./registerSlice";
import passwordSlice from "./passwordSlice";
import dashboardSlice from "./dashboardSlice";
import sentSlice from "./sentSlice";
import auditTrailSlice from "./auditTrailSlice";
import pdfSlice from "./pdfSlice";
import profileSlice from "./profileSlice";
import reportsSlice from "./reportsSlice";
import receivedSlice from "./receivedSlice";
import receivedPDFSlice from "./receivedPDFSlice";
import creditSlice from "./creditSlice";
import addCreditSlice from "./addCreditSlice";
import addUserSlice from "./addUserSlice";
import postpaidBillPaymentSlice from "./postpaidBillPaymentSlice";
import changeAccountTypeSlice from "./changeAccountTypeSlice";
import allCompanyDetailsSlice from "./allCompanyDetailsSlice";
import pdfGenrateTokenSlice from "./pdfGenrateTokenSlice";
import genrateEsignTokenWithDocumentIDSlice from "./genrateEsignTokenWithDocumentIDSlice";
import creditlogsSlice from "./creditlogsSlice";
import creditRchSlice from "./creditRechargeSlice";
const store = configureStore({
  reducer: {
    login: loginReducer,
    flag: flagReducer,
    register: registerReducer,
    password: passwordSlice,
    dashboard: dashboardSlice,
    sent: sentSlice,
    audit: auditTrailSlice,
    pdf: pdfSlice,
    profile: profileSlice,
    report: reportsSlice,
    received: receivedSlice,
    receivedPDF: receivedPDFSlice,
    creditRch: creditRchSlice,
    creditlogs: creditlogsSlice,
    credit: creditSlice,
    addCredit: addCreditSlice,
    addUser: addUserSlice,
    postpaidBillPayment: postpaidBillPaymentSlice,
    changeAccountType: changeAccountTypeSlice,
    allCompanyDetails: allCompanyDetailsSlice,
    pdfGenrateToken: pdfGenrateTokenSlice,
    genrateEsignTokenWithDocumentID: genrateEsignTokenWithDocumentIDSlice,
  },
});
export default store;
